import { useNavigate, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Team Profile", path: "/dashboard" },
  { label: "Players", path: "/dashboard", scrollTo: "players-section" },
  { label: "Tournament Rules", path: "/rules" },
  { label: "Help & Support", path: "/help" },
];

function Sidebar({ isOpen, onClose, team }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (item) => {
    if (!item.path) return; // pages not built yet
    navigate(item.path, { state: { team, scrollTo: item.scrollTo } });
    onClose();
  };

  const handleLogout = () => {
    onClose();
    navigate("/", { replace: true });
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={onClose}
        />
      )}
      <div
        className={`fixed md:static top-0 left-0 h-full md:h-auto w-56 bg-brand-dark text-brand-cream min-h-screen p-4 flex flex-col justify-between z-50 transform transition-transform duration-200 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
      >
        <div>
          <h2 className="text-lg font-bold text-brand-gold mb-6">NextGen</h2>
          <nav className="space-y-2">
            {NAV_ITEMS.map((item) => (
              <div
                key={item.label}
                onClick={() => handleClick(item)}
                className={`px-3 py-2 rounded-lg hover:bg-brand-red cursor-pointer text-sm ${
                  location.pathname === item.path &&
                  location.state?.scrollTo === item.scrollTo
                    ? "bg-brand-red"
                    : ""
                }`}
              >
                {item.label}
              </div>
            ))}
          </nav>
        </div>
        <div
          onClick={handleLogout}
          className="text-sm px-3 py-2 rounded-lg hover:bg-brand-red cursor-pointer"
        >
          Logout
        </div>
      </div>
    </>
  );
}

export default Sidebar;
